import { Flex } from "antd"
import { useTranslation } from "react-i18next"
import { Card } from "ui/Card"
import { Title, Text } from "ui/Typography"
import { spacings } from "themes/variables"

// Steps the guide completes outside DS before connecting (spec "Guide onboarding checklist").
const CHECKLIST_STEPS = ["merchant_account", "hosted_page", "tokenization", "credentials"]

const OnboardingChecklist = () => {
  const { t } = useTranslation()

  return (
    <Card>
      <Flex vertical gap={spacings.S}>
        <Title level={5}>{t("powertranz.settings.checklist.title")}</Title>
        <Flex vertical gap={spacings.XS}>
          {CHECKLIST_STEPS.map((step, index) => (
            <Text key={step}>
              {index + 1}. {t(`powertranz.settings.checklist.${step}`)}
            </Text>
          ))}
        </Flex>
      </Flex>
    </Card>
  )
}

export default OnboardingChecklist
